import { render, staticRenderFns } from "./heading-separator.vue?vue&type=template&id=6f94707b"
import script from "./heading-separator.vue?vue&type=script&lang=js"
export * from "./heading-separator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports